import { Typography } from '@mui/material';
import { PagedComments } from 'cleveron-web-components';
import React, { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import useAccess from '../../utils/useAccess';

export default function Comments({
    addComment,
    comments,
    deleteComment,
    disabled,
    domId,
    // editComment,
    fetchComments,
    itemId,
    tabs,
}) {
    const handleCommentSubmit = useCallback(
        async ({ comment }, tab) => {
            await addComment({
                comment,
                itemId,
                tab,
            });
            await fetchComments({ id: itemId });
        },
        [addComment, fetchComments, itemId]
    );

    // As per discussions with Bert I'm leaving this commented out until we decide whether we need
    // to support editing in the future or can completely remove the functionality.
    // Jira changed their comments from plain text to rich text, so the previous functionality
    // broke and requires a better implementation, or we'd just be handing a footgun for the users.
    /*
    const handleCommentEdit = useCallback(
        async ({ newValue, id }) => {
            await editComment({
                comment: newValue,
                id,
                itemId,
            });
            await fetchComments({ id: itemId });
        },
        [editComment, fetchComments, itemId]
    );
     */

    const handleCommentDelete = useCallback(
        async ({ id }) => {
            await deleteComment({ id, itemId });
            await fetchComments({ id: itemId });
        },
        [deleteComment, fetchComments, itemId]
    );

    const { isCleveron, username } = useAccess();

    const effectiveTabs = useMemo(() => tabs || [{ comments }], [comments, tabs]);
    const hasComments = effectiveTabs.some(tab => tab.comments.length);

    return disabled && !hasComments ? (
        <Typography color="textSecondary" variant="body2">
            <FormattedMessage defaultMessage="No comments" id="text.noComments" />
        </Typography>
    ) : (
        <PagedComments
            deleteEditFilter={comment => isCleveron || comment.createdBy === username}
            handleDelete={!disabled && deleteComment && handleCommentDelete}
            // handleEdit={!disabled && editComment && handleCommentEdit}
            handleSubmit={!disabled && addComment && handleCommentSubmit}
            hideTabsIfOnlyOne
            id={`${domId}PagedComments`}
            newestFirst
            pageSize={5}
            tabs={effectiveTabs}
        />
    );
}
